import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c(VBtn,_vm._b({attrs:{"color":"primary"},on:{"click":_vm.promptInstallation}},'v-btn',_vm.$attrs,false),[_vm._v(" add to homescreen "),_c(VIcon,{attrs:{"right":""}},[_vm._v(_vm._s(_vm.platformIcon))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }